// 判断登录
export const IS_LOGIN_EVENT_TYPE = 'tga-is-login-event'
export const AFTER_IS_LOGIN_EVENT_TYPE = 'tga-after-is-login-event'
// 登录
export const LOGIN_EVENT_TYPE = 'tga-login-event'
export const AFTER_LOGIN_EVENT_TYPE = 'tga-after-login-event'
// 获取用户信息
export const GET_USERINFO_EVENT_TYPE = 'tga-get-userinfo'
export const AFTER_GET_USERINFO_EVENT_TYPE = 'tga-after-get-userinfo'
// 上报游戏加载进度
export const REPORT_LOADING_PROGRESS_EVENT_TYPE = 'tga-report-loading-progress'
// 关闭游戏加载模态窗
export const CLOSE_LOADING_MODAL_EVENT_TYPE = 'tga-close-loading-modal'
// 分享
export const SHARE_EVENT_TYPE = 'tga-share'
// 上报积分
export const REPORT_SCORE_EVNET_TYPE = 'tga-report-score'
export const AFTER_REPORT_SCORE_EVNET_TYPE = 'tga-after-report-score'
// 显示排行榜模态窗
export const SHOW_RANK_MODAL_EVENT_TYPE = 'tga-show-rank-modal'
// 上报用户完成的游戏关卡
export const REPORT_LEVEL_PASSED_EVENT_TYPE = 'tga-report-level-passed'
export const AFTER_REPORT_LEVEL_PASSED_EVENT_TYPE =
  'tga-after-report-level-passed'
// 上报用户游戏通关
export const REPORT_CLEAR_GAME_EVENT_TYPE = 'tga-report-clear-game'
export const AFTER_REPORT_CLEAR_GAME_EVENT_TYPE = 'tga-after-report-clear-game'
// 上报游戏的声音状态（有声还是无声）
export const REPORT_SOUND_STATUS_EVENT_TYPE = 'tga-report-sound-status'
// 播放片头广告
export const SHOW_TITLE_AD_EVENT_TYPE = 'tga-show-title-ad'
export const HIDE_TITLE_AD_EVENT_TYPE = 'tga-hide-title-ad'
// 播放激励广告
export const SHOW_REWARD_AD_EVENT_TYPE = 'tga-show-reward-ad'
export const HIDE_REWARD_AD_EVENT_TYPE = 'tga-hide-reward-ad'
// 播放插屏广告
export const SHOW_SLOT_AD_EVENT_TYPE = 'tga-show-slot-ad'
export const HIDE_SLOT_AD_EVENT_TYPE = 'tga-hide-slot-ad'
// 播放banner广告
export const SHOW_BANNER_AD_EVENT_TYPE = 'tga-show-banner-ad'
export const HIDE_BANNER_AD_EVENT_TYPE = 'tga-hide-banner-ad'

// 日志前缀
export const LOGGER_PREFIX = 'TGA PLATFORM SDK'

// 返回状态编码
export const RESPONSE_CODE = {
  // 操作成功
  SUCCESS: 1000,
  // 操作失败
  FAIL: 2000,
  // 用户认证失败
  AUTH_INVALID: 3000
}
